
import { GoogleCalendarService } from "@/services/google-calendar-service";
import { IGoogleCalendarEventGroup } from "@/utils/google-calendar-event-group";
import Vue from "vue";
import AppWrapper from "./CalendarEventEditWrapper.vue";
import AppGoogleCalendarEventEdit from "./GoogleCalendarEventEdit.vue";

export default Vue.extend({
	props: {
		event: {
			type: Object as () => gapi.client.calendar.Event,
			required: true
		},
		srcCalendarId: String,
		maxWidth: [String, Number]
	},
	computed: {
		title(): string {
			return this.$ct(this.event.id == "" ? "new-google-event" : "edit-google-event").toString();
		},
		eventInput(): IGoogleCalendarEventGroup {
			return {
				event: this.event,
				originalCalendarId: this.srcCalendarId,
				calendarId: this.srcCalendarId
			};
		}
	},
	methods: {
		async save() {

			if (!this.eventInput.calendarId) {
				return;
			}
			if (this.event.id) {
				if (this.eventInput.calendarId != this.eventInput.originalCalendarId && this.eventInput.originalCalendarId != null) {
					await GoogleCalendarService.deleteEvent(this.eventInput.event, this.eventInput.originalCalendarId);
					this.eventInput.event.id = "";
					this.eventInput.event.etag = "";
					await GoogleCalendarService.postEvent(this.eventInput.event, this.eventInput.calendarId);
				} else {
					await GoogleCalendarService.putEvent(this.eventInput.event, this.eventInput.calendarId);
				}
			} else {
				await GoogleCalendarService.postEvent(this.eventInput.event, this.eventInput.calendarId);
			}
			this.$emit("save");
			this.$emit("close");
		},
		cancel() {
			this.$emit("close");
		},
		async deleteEvent() {
			let confirmed = await this.$confirmBuilder().setWarningTitle().setMessage(this.$ct("confirm-event-delete")).show();
			if (!confirmed) {
				return;
			}
			await GoogleCalendarService.deleteEvent(this.event, this.srcCalendarId);
			this.$emit("save");
			this.$emit("close");
		}
	},
	components: {
		AppGoogleCalendarEventEdit,
		AppWrapper
	},
	i18nEx: {
		componentPrefix: "components.calendar-GoogleCalendarEventEditCard"
	}
});
